// @core/stores/authn/Authn2FAStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { authnApi } from '@core/api';
import type {
  DisableTwoFactorAuthRequest,
  EnableTwoFactorAuthRequest,
  EnableTwoFactorAuthResponse,
  VerifyTwoFactorAuthRequest,
} from '@core/types/authn';

class Authn2FAStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Disable two-factor authentication
   */
  async DisableTwoFactorAuth(data: DisableTwoFactorAuthRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await authnApi.DisableTwoFactorAuth(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Enable two-factor authentication
   */
  async EnableTwoFactorAuth(data: EnableTwoFactorAuthRequest): Promise<EnableTwoFactorAuthResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await authnApi.EnableTwoFactorAuth(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Verify 2FA code
   */
  async VerifyTwoFactorAuth(data: VerifyTwoFactorAuthRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await authnApi.VerifyTwoFactorAuth(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const authn2FAStore = new Authn2FAStore();
